export default "__VITE_ASSET__DAQ9GS$R__"